module.exports = __webpack_public_path__ + "img/total-right.36159ad1.png";